import { Transition } from '@unseenco/taxi';
import { nextFrame } from '@studiometa/js-toolkit/utils';
import gsap from 'gsap';

/**
 * Use highway Transition
 *
 * @param object app The app.
 */
export default function defaultTransition(app) {
  /**
   * Highway transition
   */
  return class PageTransition extends Transition {
    /**
     * On enter
     * @param  {Object} options.done
     * @returns {void}
     */
    onEnter({ done }) {
      const overlay = app.$refs.transitionOverlay;

      overlay.style.transformOrigin = '100% 100%';

      gsap.to(overlay, {
        scaleX: 0,
        duration: 0.6,
        ease: 'power3.inOut',
        onComplete: () => {
          done();
          overlay.style.transformOrigin = '0 0';
          app.$update();
        },
      });
    }

    /**
     * Onleave
     * @param  {Object} options.done
     * @returns {void}
     */
    async onLeave({ done }) {
      const overlay = app.$refs.transitionOverlay;

      app.$update();

      await nextFrame();
      await nextFrame();

      overlay.style.transformOrigin = '0 0';

      gsap.to(overlay, {
        scaleX: 1,
        duration: 0.6,
        ease: 'power3.inOut',
        onComplete: () => {
          window.scroll(0, 0);
          overlay.style.transformOrigin = '100% 100%';
          done();
        },
      });
    }
  };
}
